"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Stars = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _styles = require("@material-ui/core/styles");

var _FormLabel = _interopRequireDefault(require("../FormLabel"));

var _ErrorHandlingFormHelperText = _interopRequireDefault(require("../ErrorHandlingFormHelperText"));

var _Button = _interopRequireDefault(require("../Button"));

var _styles2 = require("./styles");

var _starRating = _interopRequireDefault(require("./lib/star-rating"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var Stars = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(Stars, _Component);

  var _super = _createSuper(Stars);

  function Stars() {
    var _this;

    (0, _classCallCheck2.default)(this, Stars);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onClear", function () {
      _this.props.onChange && _this.props.onChange(null);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "render", function () {
      var _this$props = _this.props,
          id = _this$props.id,
          totalStars = _this$props.totalStars,
          editable = _this$props.editable,
          value = _this$props.value,
          onChange = _this$props.onChange,
          _this$props$size = _this$props.size,
          size = _this$props$size === void 0 ? 24 : _this$props$size,
          label = _this$props.label,
          error = _this$props.error,
          helperText = _this$props.helperText,
          errorMessage = _this$props.errorMessage,
          className = _this$props.className,
          starSpacing = _this$props.starSpacing,
          starRatedColor = _this$props.starRatedColor,
          starEmptyColor = _this$props.starEmptyColor,
          starHoverColor = _this$props.starHoverColor,
          classes = _this$props.classes;
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, label && /*#__PURE__*/_react.default.createElement(_FormLabel.default, {
        id: id,
        error: error
      }, label), /*#__PURE__*/_react.default.createElement("div", {
        className: (0, _classnames.default)("prmbl-stars", className, classes.stars)
      }, /*#__PURE__*/_react.default.createElement(_starRating.default, {
        id: id,
        numberOfStars: totalStars,
        rating: value || 0,
        disabled: _this.props.disabled,
        changeRating: onChange,
        starDimension: "".concat(size, "px"),
        starSpacing: "".concat(starSpacing, "px"),
        starRatedColor: starRatedColor,
        starEmptyColor: starEmptyColor,
        starHoverColor: starHoverColor,
        "aria-describedby": "".concat(id, "-helper-text")
      })), editable && value != null && value !== 0 && /*#__PURE__*/_react.default.createElement(_Button.default, {
        id: "".concat(id, "-stars-clear-button"),
        onClick: _this.onClear,
        disabled: _this.props.disabled
      }, "Clear"), /*#__PURE__*/_react.default.createElement(_ErrorHandlingFormHelperText.default, {
        id: id,
        error: error,
        helperText: helperText,
        errorMessage: errorMessage
      }));
    });
    return _this;
  }

  return Stars;
}(_react.Component);

exports.Stars = Stars;
(0, _defineProperty2.default)(Stars, "propTypes", {
  /**
   * The html id
   */
  id: _propTypes.default.string.isRequired,

  /**
   * The total numbers of stars to display
   */
  totalStars: _propTypes.default.number,

  /**
   * If true, the user will be able to select a rating. Otherwise, it will just show the rating.
   */
  editable: _propTypes.default.bool,

  /**
   * The amount of stars currently being shown.
   */
  value: _propTypes.default.number,

  /**
   * The function to be called when the rating has been selected/changed.
   */
  onChange: _propTypes.default.func,

  /**
   * The size of the stars in pixels. Default: 24.
   */
  size: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),

  /**
   * Whether to allow half stars or not. Default: false.
   */
  useHalfStars: _propTypes.default.bool,

  /**
   * The label to show above the stars.
   */
  label: _propTypes.default.string,

  /**
   * Whether the validation says there is an error or not.
   */
  error: _propTypes.default.bool,

  /**
   * The small text to show beneath the stars.
   */
  helperText: _propTypes.default.string,

  /**
   * The message to show when the error property is true.
   */
  errorMessage: _propTypes.default.string,

  /**
   * classes to be used on the div around the Stars component
   */
  classes: _propTypes.default.object,

  /**
   * @ignore
   *
   * Utilized By:
   * CivicEngage, CP Platform
   */
  className: _propTypes.default.string,

  /**
   * The spacing between the stars, default 0
   */
  starSpacing: _propTypes.default.number,

  /**
   * Color of stars that the user has rated, default #ffd700
   */
  starRatedColor: _propTypes.default.string,

  /**
   * Color of stars that the use hasn't rated, default gray
   */
  starEmptyColor: _propTypes.default.string,

  /**
   * Color of star when hovering over it in selection mode, default #ffd700
   */
  starHoverColor: _propTypes.default.string,

  /**
   * If the input is disabled.
   */
  disabled: _propTypes.default.bool
});
(0, _defineProperty2.default)(Stars, "defaultProps", {
  className: "",
  starSpacing: 0,
  starRatedColor: "#ffd700",
  starEmptyColor: "gray",
  starHoverColor: "#ffd700"
});

var _default = (0, _styles.withStyles)(_styles2.styles)(Stars);

exports.default = _default;